import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';

import { Translate, useInterpolatedTranslationKey } from '@dreryk/react-common';
import { StrongText } from '@dreryk/react-components';

import { medicalLeaveFormTranslationKeys } from '../../../../../translations';

type PatientPersonalDataTextProps = {
   readonly patient: VisitPatient;
};

export const PatientPersonalDataText = (props: PatientPersonalDataTextProps): JSX.Element => {
   return (
      <StrongText testId={'patientName'}>
         <Translate>
            {useInterpolatedTranslationKey(medicalLeaveFormTranslationKeys.patientName, {
               firstName: props.patient.firstName?.asString(),
               lastName: props.patient.lastName?.asString(),
            })}
         </Translate>
      </StrongText>
   );
};
